"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _stores = require("@seedlang/stores");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _layouts = require("@seedlang/layouts");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _root_state = _interopRequireDefault(require("./root_state"));
var _constants = require("@seedlang/constants");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var TreeUI = (_class = /*#__PURE__*/function (_RootState) {
  function TreeUI() {
    var _this;
    _classCallCheck(this, TreeUI);
    _this = _callSuper(this, TreeUI);
    _initializerDefineProperty(_this, "trees", _descriptor, _this);
    _initializerDefineProperty(_this, "treeNodeId", _descriptor2, _this);
    _initializerDefineProperty(_this, "loadingTree", _descriptor3, _this);
    _initializerDefineProperty(_this, "showFollowingIndex", _descriptor4, _this);
    _initializerDefineProperty(_this, "clickedPlayRandomOpponent", _descriptor5, _this);
    _initializerDefineProperty(_this, "treeSlug", _descriptor6, _this);
    _this.layout = new _layouts.AppLayout(_this);
    _this.userStore = _stores.UserStore;
    _this.treeNodeStore = _stores.TreeNodeStore;
    _this.deckTreeNodeStore = _stores.DeckTreeNodeStore;
    _this.treeStore = _stores.TreeStore;
    _this.conceptStore = _stores.ConceptStore;
    _this.conceptCategoryStore = _stores.ConceptCategoryStore;
    _this.sentenceConceptStore = _stores.SentenceConceptStore;
    _this.sentenceStore = _stores.SentenceStore;
    _this.wordCountStore = _stores.WordCountStore;
    _this.wordStore = _stores.WordStore;
    _this.wordTypeStore = _stores.WordTypeStore;
    _this.deckStore = _stores.DeckStore;
    _this.userTreeNodeStore = _stores.UserTreeNodeStore;
    _this.conceptWordStore = _stores.ConceptWordStore;
    _this.routeStore = _stores.RouteStore;
    _this.authUserStore = _stores.AuthUserStore;
    _this.followAssociationStore = _stores.FollowAssociationStore;
    _this.invitationStore = _stores.InvitationStore;
    _this.challengeStore = _stores.ChallengeStore;
    _this.deckWordStore = _stores.DeckWordStore;
    _this.userDeckStore = _stores.UserDeckStore;
    return _this;
  }
  _inherits(TreeUI, _RootState);
  return _createClass(TreeUI, [{
    key: "sentencesSeenCount",
    get: function get() {
      var _this2 = this;
      if (this.userIsLoaded) {
        var userTreeNode = this.userTreeNodeStore.indexData.find(function (item) {
          return item.treeNodeId === _this2.treeNodeId;
        });
        return (0, _utils.isPresent)(userTreeNode) ? userTreeNode.sentencesSeenCount : 0;
      }
      return null;
    }
  }, {
    key: "triviaTreeNode",
    get: function get() {
      var _this3 = this;
      return (0, _utils.isPresent)(this.triviaTree) ? this.triviaTree.treeNodes.find(function (item) {
        return item.id === _this3.treeNodeId;
      }) : {};
    }
  }, {
    key: "disableStartNewTriviaGame",
    get: function get() {
      return !this.user.isMember && this.user.freeGamesAvailableCount <= 0;
    }
  }, {
    key: "triviaHasPublishedSentences",
    get: function get() {
      return this.triviaTreeNode && this.triviaTreeNode.publishedSentencesCount > 0;
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      return (0, _utils.isPresent)(this.user);
    }
  }, {
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "hasTree",
    get: function get() {
      return (0, _utils.isPresent)(this.tree);
    }
  }, {
    key: "hasStoriesTree",
    get: function get() {
      return (0, _utils.isPresent)(this.storiesTree);
    }
  }, {
    key: "hasTreeNode",
    get: function get() {
      return this.treeNodeStore.hasShowData;
    }
  }, {
    key: "treeNode",
    get: function get() {
      return this.treeNodeStore.showData;
    }
  }, {
    key: "tree",
    get: function get() {
      var _this$treeSlug;
      if (this.treeSlug === 'master') {
        return this.storiesTree;
      }
      if (this.treeSlug === 'trivia') {
        return this.triviaTree;
      }
      if ((_this$treeSlug = this.treeSlug) !== null && _this$treeSlug !== void 0 && _this$treeSlug.endsWith('grammar')) {
        return this.grammarTree;
      }
      return null;
    }
  }, {
    key: "treeRow",
    get: function get() {
      var _this4 = this;
      if (this.hasTree) {
        return this.tree.treeRows.find(function (item) {
          return item.id === _this4.treeNode.treeRowId;
        });
      }
      return null;
    }
  }, {
    key: "treeRows",
    get: function get() {
      if (this.hasTree) {
        return (0, _lodash.flatten)(this.tree.treeModules.map(function (item) {
          return item.treeRows;
        }));
      }
      return null;
    }
  }, {
    key: "storiesTreeRows",
    get: function get() {
      if (this.storiesTree) {
        return (0, _lodash.flatten)(this.storiesTree.treeModules.map(function (item) {
          return item.treeRows;
        }));
      }
      return null;
    }
  }, {
    key: "treeNodes",
    get: function get() {
      if (this.hasMasterTree && this.treeRows) {
        return (0, _lodash.flatten)(this.treeRows.map(function (item) {
          return item.treeNodes;
        }));
      }
      return null;
    }
  }, {
    key: "storiesTreeNodes",
    get: function get() {
      if (this.storiesTree && this.storiesTreeRows) {
        return (0, _lodash.flatten)(this.storiesTreeRows.map(function (item) {
          return item.treeNodes;
        }));
      }
      return null;
    }
  }, {
    key: "treeModule",
    get: function get() {
      var _this5 = this;
      if (this.hasTree) {
        return this.tree.treeModules && this.tree.treeModules.find(function (item) {
          return item.id === _this5.treeNode.treeModuleId;
        });
      }
      return null;
    }
  }, {
    key: "triviaTree",
    get: function get() {
      return this.trees.trivia;
    }
  }, {
    key: "grammarTree",
    get: function get() {
      if (this.layout.isNative) {
        return this.trees.fr_grammar || this.trees.es_grammar || this.trees.de_grammar;
      } else {
        switch (this.user.targetLanguageId) {
          case 'FR':
            return this.trees.fr_grammar;
          case 'ES':
            return this.trees.es_grammar;
          default:
            return this.trees.de_grammar;
        }
      }
    }
  }, {
    key: "storiesTree",
    get: function get() {
      if (this.layout.isNative) {
        return this.trees.french || this.trees.spanish || this.trees.master;
      } else {
        switch (this.user.targetLanguageId) {
          case 'FR':
            return this.trees.french;
          case 'ES':
            return this.trees.spanish;
          default:
            return this.trees.master;
        }
      }
    }
  }, {
    key: "showStoriesNewLabel",
    get: function get() {
      return this.hasStoriesTree && (0, _lodash.some)(this.storiesTree.treeNodes.map(function (item) {
        return item.webPublished && item.webPublishedInLastWeek;
      }));
    }
  }, {
    key: "treeRowsLesserEqualTo",
    value: function treeRowsLesserEqualTo(position) {
      return this.tree.treeRows.filter(function (item) {
        return item.position <= position;
      });
    }
  }, {
    key: "treeRowsGreaterThan",
    value: function treeRowsGreaterThan(position) {
      return this.tree.treeRows.filter(function (item) {
        return item.position > position;
      });
    }
  }, {
    key: "clearTrees",
    value: function clearTrees() {
      this.trees = {};
    }
  }, {
    key: "loadTreesFromTargetLanguage",
    value: function loadTreesFromTargetLanguage(languageId, callback) {
      if (!languageId || languageId === 'undefined') {
        return;
      }
      this.loadTree(_constants.Constants.STORY_TREE_BY_LANGUAGE[languageId], callback);
      // this.loadTree(Constants.GRAMMAR_TREE_BY_LANGUAGE[languageId]);
      if (languageId === 'DE') {
        this.loadTree('trivia');
      }
    }
  }, {
    key: "loadTree",
    value: function loadTree(slug, callback) {
      this.treeSlug = slug;
      var queryStrings = slug === 'master' ? {
        include_first_module: true
      } : {};
      if ((0, _utils.isPresent)(slug) && !this.trees[slug]) {
        this.loadingTree = true;
        this.treeStore.clearShowData();
        this.treeStore.getShow({
          queryStrings: queryStrings,
          ids: {
            treeId: slug
          }
        }, this.afterLoadTree.bind(this, slug, callback));
      }
    }
  }, {
    key: "afterLoadTree",
    value: function afterLoadTree(slug, callback, resp) {
      if (resp) {
        this.treeStore.setShowData(resp);
        if (!this.trees[slug]) {
          this.trees[slug] = this.treeStore.showData;
        }
        this.loadingTree = false;
        if (callback) {
          callback(resp);
        }
      }
    }
  }, {
    key: "onClickPlayTrivia",
    value: function onClickPlayTrivia() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.disableStartNewTriviaGame && (this.triviaHasPublishedSentences || params.callback) && !this.clickedPlayRandomOpponent) {
        var callback = params.callback || this.afterChooseDeck.bind(this, params.opponentId);
        this.clickedPlayRandomOpponent = true;
        this.treeNodeStore.chooseDeck({
          queryStrings: {
            opponent_id: params.opponentId
          },
          ids: {
            treeNodeId: this.treeNodeId || params.treeNodeId
          }
        }, callback);
      }
    }
  }, {
    key: "afterChooseDeck",
    value: function afterChooseDeck(opponentId, resp) {
      this.clickedPlayRandomOpponent = false;
      if (opponentId) {
        this.routeStore.routeToNamed('trivia.tree_nodes.decksWithOpponent.show', {
          opponentId: opponentId,
          treeNodeId: this.treeNodeId,
          deckId: resp.deckId
        });
      } else {
        this.routeStore.routeToNamed('trivia.tree_nodes.decks.show', {
          treeNodeId: this.treeNodeId,
          deckId: resp.deckId
        });
      }
    }
  }, {
    key: "triviaReset",
    value: function triviaReset() {
      this.showFollowingIndex = false;
      this.loadingTree = false;
    }
  }, {
    key: "onChallengeUser",
    value: function onChallengeUser(userId) {
      this.challengeStore.indexData.push({
        userId: this.user.id,
        challengeeId: userId,
        treeNodeId: this.treeNodeId
      });
      this.challengeStore.create({
        data: {
          treeNodeId: this.treeNodeId,
          challengeeId: userId
        }
      }, _lodash.noop);
    }
  }, {
    key: "challengeIssued",
    value: function challengeIssued(userId) {
      return (0, _utils.isPresent)(this.challengeStore.indexData.find(function (item) {
        return item.challengeeId === userId;
      }));
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "trees", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "treeNodeId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "loadingTree", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showFollowingIndex", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "clickedPlayRandomOpponent", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "treeSlug", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "sentencesSeenCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "sentencesSeenCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaTreeNode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaTreeNode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableStartNewTriviaGame", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableStartNewTriviaGame"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaHasPublishedSentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaHasPublishedSentences"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasTree", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasTree"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasStoriesTree", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasStoriesTree"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasTreeNode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasTreeNode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "treeNode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "treeNode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tree", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "tree"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "treeRow", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "treeRow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "treeRows", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "treeRows"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "storiesTreeRows", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "storiesTreeRows"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "treeNodes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "treeNodes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "storiesTreeNodes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "storiesTreeNodes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "treeNodes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "treeNodes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "treeModule", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "treeModule"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaTree", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaTree"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "grammarTree", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "grammarTree"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "storiesTree", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "storiesTree"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showStoriesNewLabel", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showStoriesNewLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearTrees", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "clearTrees"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadTreesFromTargetLanguage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "loadTreesFromTargetLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadTree", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "loadTree"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterLoadTree", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterLoadTree"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClickPlayTrivia", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onClickPlayTrivia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterChooseDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterChooseDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaReset", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "triviaReset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChallengeUser", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onChallengeUser"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "challengeIssued", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "challengeIssued"), _class.prototype), _class);
var _default = exports["default"] = new TreeUI();